import { isUserAuthenticated } from "@/middleware/auth";
import {
  getChatFromLocalDB,
  updateChatInLocalDB,
} from "@/indexedDB/services/chats";

import { ResetCounterEventType } from "./types";

export const handleResetCounterEvent = async (data: ResetCounterEventType) => {
  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  const chatDetails = await getChatFromLocalDB(data.reset_chat_counter.chat_id);
  if (!chatDetails) {
    return;
  }

  await updateChatInLocalDB(data.reset_chat_counter.chat_id, {
    unreadCount: 0,
  });
};
